import React, {useState} from 'react'
import { ButtonDropdown, 
		DropdownToggle, 
		DropdownMenu, 
		DropdownItem, 
		Label, 
		FormGroup, 
		Input,
		Row,
		Col,
		Button
		 } from 'reactstrap';
import { DownloadIcon, CalenderIcon } from "../Icon";
import moment from 'moment';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

interface Props {
	downloadInvoice?: (params:any)=> void;
	client_code?:number;
	type?:string;
}

const DownloadReport =({
	downloadInvoice,
	client_code,
	type
}:Props)=>{

	const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);

 	const [startDate, setStartDate] = useState<any>(null);
  	const [endDate, setEndDate] = useState<any>(null);
  	const [dateType, setDateType] = useState<string>('');
  	const [dateOfInvoiceType, setDateOfInvoiceType] = useState<string>('');

  	const toggle = () => {
		  setDropdownOpen(prevState => !prevState);
		  handleDateSelect()
	  }

  	// const onChange = (dates:any) => {
   //  	const [start, end] = dates;
   // 		setStartDate(start);
   // 	 	setEndDate(end);
  	// };

	const handleDownload =()=>{
		let params ={
			'start_date' :moment(startDate).format('DD-MM-YYYY'),
			'end_date' 	 :moment(endDate).format('DD-MM-YYYY'),
			'client_code': client_code?client_code:'',
			'type'		: type?type:'',
			'date_type' :  dateType
		}
		
		params && downloadInvoice && downloadInvoice(params)
	}
	const handleCancel =()=>{
		setStartDate(null)
		setEndDate(null)

	}
	const handleStartDate =(date:any)=>{
		setStartDate(date)
		setEndDate(null)
	}

	const handleDateSelect =()=>{
		switch(type){
			case 'revenue': return setDateOfInvoiceType('invoice_voucher_date');
			case 'expenses': return setDateOfInvoiceType('voucher_invoice_date');
			case 'others'	: return setDateOfInvoiceType('date');
			default: return;
		}
	}

	return (
		<>
        	<ButtonDropdown 
        	  	isOpen={dropdownOpen} 
        	  	toggle={toggle}
        	  	className="download-report-btn"
        	>
				<DropdownToggle 
				 	caret 
				 	color="secondary" 
        	  		outline

        	  	>
					<DownloadIcon /> Download Reports
				</DropdownToggle>

	        		<DropdownMenu right>
	        			<div className="download-dropdown p-3">
	        			<h4>Download Report</h4>
						
                        <FormGroup>
					        {/* <Label for="dateType">Select</Label> */}
					        <Input 
					        	type="select" 
					        	name="select" 
					        	id="dateType"
					        	//value={dateType}
					        	onChange={(e)=>setDateType(e.target.value)}
					        >
							  <option value="" disabled selected>Select your option</option>
					          <option value={dateOfInvoiceType}>Date of Invoice</option>
					          <option value="updated_at">Date Added/Modified</option>
					        </Input>
					      </FormGroup>

					    <Row>
					    	<Col md={6} className="form-group">
						    	<div>Start Date </div>
						    	<Row>
						    		
						    		<Col md="12" className="download-report-picker">
						    		  <Label className="m-0 p-0">
						    			<span className="calender-icon">
						    				<CalenderIcon  />
						    			</span>
	                        			<DatePicker
			                        		dateFormat="dd-MM-yyyy"
									        selected={startDate}
									        onChange={handleStartDate}
									        selectsStart
											showMonthDropdown
											showYearDropdown
									        startDate={startDate}
									        endDate={endDate}
									        className="form-control"
									    />
									    </Label>
									</Col>
								</Row>
						    </Col>
					    	<Col md={6} className="form-group">
						    	<div>End Date</div>
							    <Row>
							    	<Col md="12" className="download-report-picker">
							    	  <Label className="m-0 p-0">
						    			<span className="calender-icon">
						    				<CalenderIcon  />
						    			</span>
									    <DatePicker
									    	dateFormat="dd-MM-yyyy"
									        selected={endDate}
									        onChange={(date:any) => setEndDate(date)}
									        selectsEnd
											peekNextMonth
											showMonthDropdown
											showYearDropdown
									        startDate={startDate}
									        endDate={endDate}
									        minDate={startDate}
									           className="form-control"
									    />
									    </Label>
									</Col>
								</Row>
					    	</Col> 
					    	<Col md={12} className="text-right">

					    		<button className="btn btn-outline-secondary mr-3" onClick={handleCancel}>Cancel</button>
					    	  	<button 
									className="btn btn-primary" 
					            	onClick={handleDownload}
					            	disabled={startDate && endDate && dateType ? false : true}
					        	>
					           		DownLoad
					        	</button> 
					    	</Col> 
					      </Row>
						</div>
	        		</DropdownMenu>
        	</ButtonDropdown>
        </>
	)

}

export default DownloadReport;